module.exports = __webpack_public_path__ + "69448f117ff8c4a391d127f635125d69.png";